import React from "react";
import { Alert, App, Space, Typography } from "antd";

const { Paragraph, Text } = Typography;

/** Çözümleyici anahtarı yalnız bir kez gelir; kullanıcıya kopyalayabileceği şekilde gösterilir. */
export const showResolverApiKey = (
  modal: ReturnType<typeof App.useApp>["modal"],
  apiKey: string,
  t: (key: string, fallback?: string) => string
) =>
  modal.info({
    title: t("RESOLVER_KEY_MODAL_TITLE", "Your API key"),
    width: 560,
    okText: t("RESOLVER_KEY_MODAL_OK", "I have saved it"),
    content: (
      <Space direction="vertical" style={{ width: "100%" }}>
        <Alert
          type="warning"
          showIcon
          message={t(
            "RESOLVER_KEY_SHOWN_ONCE",
            "This key is shown only once. Store it somewhere safe; it cannot be displayed again."
          )}
        />
        <Paragraph copyable={{ text: apiKey }} style={{ marginBottom: 0 }}>
          <Text code style={{ wordBreak: "break-all" }}>
            {apiKey}
          </Text>
        </Paragraph>
      </Space>
    ),
  });
